<template>
<div class="footer">
  <div class="footer__nav">
    <a
      v-if="qualification && qualification.contactEmail"
      :href="`mailto:${qualification.contactEmail}`"
      class="_flex:row _flex:align(center) _text:sm _m:right(3)"
    >
      <ds ds="icon" class="_m:right(2)" name="message" size="13px" />
      <span>{{ $t('component.Footer.links.contactUs') }}</span>
    </a>
    <a
      v-if="qualification && qualification.supportUrl"
      :href="qualification.supportUrl"
      target="_blank"
      link="rel"
      noopener noreferrer
      class="_flex:row _flex:align(center) _text:sm"
    >
      <ds ds="icon" class="_m:right(2)" name="help" size="13px" color="var(--white)" />
       <span>{{ $t('component.Footer.links.help') }}</span>
    </a>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Footer',
  computed: {
    ...mapGetters(
      {
        qualification: 'qualification/qualification'
      }
    )
  }
};
</script>

<style lang="less" scoped>
@import "~@/utils.less";

.footer {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 calc(var(--gw) * 2);
  background-color: var(--black);
  position: fixed;
  z-index: 9990;
  left: 0;
  bottom: 0;
  right: 0;
  ._text\:xs;

  &__nav {
    display: flex;
    flex: 1 1;
    justify-content: flex-end;

    a {
      color: var(--white);
      margin-left: calc(var(--gw) * 1.5);
      cursor: pointer;
      opacity: 0.7;
    }

    a:hover {
      opacity: 1;
    }
  }
}

</style>
